import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SnackBarService } from '@shared/services/snack-bar.service';
import { catchError, EMPTY, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AssessmentUser } from '../models/assessment-user.model';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';

@Injectable()
export class UserApiService {
  readonly http = inject(HttpClient);
  private readonly _messageService = inject(SnackBarService);
  readonly url = `${environment.apiUrl}/users`;

  getAssessmentCreators$(): Observable<AssessmentUser[]> {
    return this.http.get<AssessmentUser[]>(`${this.url}/assessment-creators`).pipe(
      catchError(error => {
        this._messageService.showError(`Failed to retrieve assessment creators: ${error.error.message ?? GENERAL_ERROR_MESSAGE}.`);
        return EMPTY;
      })
    );
  }
}
